import _regeneratorRuntime from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": "max-double-line"
};
import { TUIStore, StoreName, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { computed } from "../../../../../adapter-vue";
import { isUniFrameWork } from "../../../../../utils/env";
import { getBoundingClientRect, getScrollInfo } from "../../../../../utils/universal-api/domOperation";
import { Toast, TOAST_TYPE } from "../../../../../components/common/Toast/index";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: {
      "default": function _default() {
        return {};
      }
    }
  },
  emits: ["scrollTo", "blinkMessage"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var selfAddValue = 0;
    var _messageList = [];
    TUIStore.watch(StoreName.CHAT, {
      messageList: function messageList(list) {
        _messageList = list;
      }
    });
    var quoteContent = computed(function () {
      try {
        var _props$message;
        var cloudCustomData = JSON.parse(((_props$message = props.message) === null || _props$message === void 0 ? void 0 : _props$message.cloudCustomData) || "{}");
        return cloudCustomData.messageReply;
      } catch (error) {
        return undefined;
      }
    });
    function scrollToOriginalMessage() {
      return _scrollToOriginalMessage.apply(this, arguments);
    }
    function _scrollToOriginalMessage() {
      _scrollToOriginalMessage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _quoteContent$value;
        var originMessageID, isOriginalMessageInScreen, scrollViewRect, originalMessageRect, _yield$getScrollInfo, scrollTop, finalScrollTop, isNeedScroll, scrollView;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              originMessageID = (_quoteContent$value = quoteContent.value) === null || _quoteContent$value === void 0 ? void 0 : _quoteContent$value.messageID;
              isOriginalMessageInScreen = _messageList.some(function (msg) {
                return msg.ID === originMessageID;
              });
              if (!(originMessageID && isOriginalMessageInScreen)) {
                _context.next = 25;
                break;
              }
              _context.prev = 3;
              _context.next = 6;
              return getBoundingClientRect('#messageScrollList', 'messageList');
            case 6:
              scrollViewRect = _context.sent;
              _context.next = 9;
              return getBoundingClientRect('#tui-' + originMessageID, 'messageList');
            case 9:
              originalMessageRect = _context.sent;
              _context.next = 12;
              return getScrollInfo('#messageScrollList', 'messageList');
            case 12:
              _yield$getScrollInfo = _context.sent;
              scrollTop = _yield$getScrollInfo.scrollTop;
              finalScrollTop = originalMessageRect.top + scrollTop - scrollViewRect.top - selfAddValue++ % 2;
              isNeedScroll = originalMessageRect.top < scrollViewRect.top;
              if (!isUniFrameWork && window) {
                scrollView = document.getElementById('messageScrollList');
                if (isNeedScroll && scrollView) {
                  scrollView.scrollTop = finalScrollTop;
                }
              } else if (isUniFrameWork && isNeedScroll) {
                emits('scrollTo', finalScrollTop);
              }
              emits('blinkMessage', originMessageID);
              _context.next = 23;
              break;
            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](3);
              console.error(_context.t0);
            case 23:
              _context.next = 26;
              break;
            case 25:
              Toast({
                message: TUITranslateService.t("TUIChat.无法定位到原消息"),
                type: TOAST_TYPE.WARNING
              });
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 20]]);
      }));
      return _scrollToOriginalMessage.apply(this, arguments);
    }
    return function (_ctx, _cache) {
      return _unref(quoteContent) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass(["reference-content", props.message.flow === 'in' || 'reverse']),
        onClick: scrollToOriginalMessage
      }, [_createElementVNode("div", _hoisted_1, _toDisplayString(_unref(quoteContent).messageSender) + ": " + _toDisplayString(_unref(quoteContent).messageAbstract), 1)], 2)) : _createCommentVNode("", true);
    };
  }
});